<template>
  <div>
    <div class="page-title">New Event</div>
    <Form v-if="form" v-model="form" :submit="create" btnText="Add Event" />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.events.page.vue";

export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async create() {
      await this.$api.Event.create(this.form);

      this.$router.push("/events");
    },
    async setForm() {
      const { data } = await this.$api.Event.new();
      this.form = data;
    },
  },
};
</script>

<style></style>
